// extracted by mini-css-extract-plugin
export default {"options":"Options_options__vLxbt","button":"Options_button__jH3Lj"};